'use client';

import Link from 'next/link';
import { Data, Login, Warning2 } from 'iconsax-react';
import { X } from 'react-feather';
import { OtpContent, OtpFooter, OtpHandler, OtpHeader, OtpInput } from '@features/otpHandler';
import { Button } from '@shared/ui';
import { Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle } from '@shared/ui/drawer';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@shared/ui/modals/modal';
import { sejamCheckText, useSejamCheck } from '../model';

export const SejamCheckModal = () => {
  const { isMobile, modal, shouldUpdate, otpConfig, action } = useSejamCheck();

  const title = shouldUpdate ? sejamCheckText.getSejamInfo : sejamCheckText.sejamRegister;

  const notice = shouldUpdate ? sejamCheckText.updateNotice : sejamCheckText.registerNotice;

  const renderAction = (className: string) => {
    if (shouldUpdate) {
      return (
        <Button onClick={action.SendOtp} type='button' className={className}>
          {sejamCheckText.getConfirmationCode}
        </Button>
      );
    }

    return (
      <Link target='_blank' href={sejamCheckText.sejamProfileUrl}>
        <Button type='button' className={`${className} gap-1`}>
          <Login size={16} />
          {sejamCheckText.registerInSejam}
        </Button>
      </Link>
    );
  };

  const content = (
    <div className='flex flex-col items-center justify-center gap-5'>
      <div className='flex w-full flex-row gap-2 bg-[#F236450D] p-4 text-red-1'>
        <Warning2 className='text-red-1' />

        <p className='body-14-regular'>{sejamCheckText.officialNotice}</p>
      </div>

      <p className='body-12-regular leading-[200%]'>{notice}</p>

      {!shouldUpdate && (
        <>
          <p className='body-12-regular leading-[200%]'>{sejamCheckText.ResponsibilityNotice}</p>
          <p className='body-12-regular pb-2 leading-[200%]'>
            {sejamCheckText.alreadyRegisteredNotice}
          </p>
        </>
      )}

      <div className='w-full'>
        {renderAction(
          isMobile
            ? 'mt-2 flex h-[60px] w-full justify-self-center self-center text-center'
            : 'my-5 flex h-[60px] w-full justify-self-center self-center text-center'
        )}
      </div>
    </div>
  );

  return (
    <>
      {isMobile ? (
        <Drawer open={modal.open} onOpenChange={modal.setOpen}>
          <DrawerContent showHandle={false}>
            <DrawerHeader className='flex items-center justify-between'>
              <DrawerTitle className='text-right text-text body-13-bold leading-normal'>
                {title}
              </DrawerTitle>

              <DrawerClose
                className='rounded-md p-1 text-text hover:bg-hover focus-visible:outline-none'
                onClick={() => modal.setOpen(false)}
              >
                <X size={24} strokeWidth={1} />
              </DrawerClose>
            </DrawerHeader>

            <div className='px-0 pt-5'>{content}</div>
          </DrawerContent>
        </Drawer>
      ) : (
        <Dialog open={modal.open} onOpenChange={modal.setOpen}>
          <DialogContent className='max-w-[455px]'>
            <DialogHeader>
              <DialogTitle className='text-right text-text body-13-bold leading-normal'>
                {title}
              </DialogTitle>

              <DialogClose
                className='rounded-md p-1 text-text hover:bg-hover focus-visible:outline-none'
                onClick={() => modal.setOpen(false)}
              >
                <X size={24} strokeWidth={1} />
              </DialogClose>
            </DialogHeader>

            <div className='px-4 pt-5'>{content}</div>
          </DialogContent>
        </Dialog>
      )}

      <OtpHandler config={otpConfig}>
        <OtpContent className='w-full md:max-w-[445px]'>
          <OtpHeader icon={<Data />}>{sejamCheckText.callSejamInfo}</OtpHeader>
          <OtpInput />
          <OtpFooter />
        </OtpContent>
      </OtpHandler>
    </>
  );
};
